import {CreateSheet} from 'aphrodite';
import {Accent1, LightGray, WhiteText} from 'src/themes/colors';

export default CreateSheet({
    container: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: 8,
        cursor: 'pointer',
    },
    wrap: {
        position: 'relative',
        display: 'inline-block',
        width: 44,
        height: 26,
    },
    checkbox: {
        position: 'absolute',
        opacity: 0,
        width: 0,
        height: 0,
        ':focus-visible + span': {
            outline: '2px solid rgba(0,0,0,0.6)',
            outlineOffset: 2,
            borderRadius: 999,
        },
        ':checked + span': {
            background: Accent1,
        },
        ':checked + span > span': {
            transform: 'translateX(18px)',
        },
        ':disabled + span': {
            opacity: 0.6,
            cursor: 'not-allowed',
        },
    },
    track: {
        position: 'absolute',
        inset: 0,
        background: LightGray,
        borderRadius: 999,
        transition: 'background 160ms ease',
    },
    knob: {
        position: 'absolute',
        top: 3,
        left: 3,
        width: 20,
        height: 20,
        borderRadius: '50%',
        background: WhiteText,
        boxShadow: '0 1px 2px rgba(0,0,0,0.3)',
        transition: 'transform 160ms ease',
    },
    text: {
        userSelect: 'none',
        lineHeight: '26px',
    },
});
